import { ValuesOf } from '@tmapy/beetlejuice-utils';

export const GEODESIST_IS_ACTIVE = { TRUE: 'TRUE', FALSE: 'FALSE' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type GEODESIST_IS_ACTIVE = ValuesOf<typeof GEODESIST_IS_ACTIVE>;
